exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer[data-v-0732b5fe] {\n  font-size: 24px;\n  color: #000;\n}\n", ""]);

// exports
